export default "__VITE_ASSET__HXrg76PB__"